module.exports = __webpack_public_path__ + "img/null-data-bg.f8b8ed68.png";